module.exports = __webpack_public_path__ + "static/media/02.98cb4793.jpg";